
import React from "react"
import { getHostURl } from "services/core"
import { Util } from "common/util"

export default function EmployeeProfile(props) {
   return (
      <div className="title" id="leave-title">
         <div
            className="profile"
            style={{ display: "flex", alignItems: "center" }}
         >
            <div className="task-image">
               {props.photo ? (
                  <img src={`${getHostURl()}/public/uploads/profile/${props.photo}?v=${Date.now()}`} alt="employee profile" />
               ) : (
                  <span>
                     {props.employeeName && Util.getInstance().getFristCharater(props.employeeName)}
                  </span>
               )}
            </div>
            <span style={{ marginLeft: "20px" }}>{props.employeeName}</span>
         </div>
      </div>
   )
}
